import React from 'react';

/**
 * §3 — the mid-spine fork compose pill (distinct from the 📍 reply cursor pill):
 * a teal ⑂ "New path from …" chip with an × that exits fork mode.
 *
 * Presentational + dependency-free on purpose — keeps it unit-testable without
 * pulling ConversationInterface's import.meta chain. The in-flight cue is the FR
 * camp's native pending state (F5), NOT a pill morph — so this pill is static copy.
 */
export function ForkComposePill({
  pillCopy,
  darkMode,
  onCancel,
}: {
  pillCopy?: string;
  darkMode: boolean;
  onCancel: () => void;
}) {
  return (
    <div
      data-fork-cursor-pill
      className={`flex items-center gap-1.5 text-xs mb-1 px-2 py-0.5 rounded-full w-fit ${
        darkMode ? 'bg-teal-900/40 text-teal-200' : 'bg-teal-100 text-teal-800'
      }`}
    >
      <span aria-hidden>⑂</span>
      <span>{pillCopy ?? 'New path from here'}</span>
      <button
        type="button"
        aria-label="Cancel fork"
        onClick={onCancel}
        className={`ml-0.5 rounded px-1 ${darkMode ? 'hover:bg-teal-800' : 'hover:bg-teal-200'}`}
      >
        ×
      </button>
    </div>
  );
}
